import {omit} from 'lodash';
import React, {FC} from 'react';

import {Handler, RendererOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {SimpleDropdown} from '../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown';
import {PopoverTransferProps} from '../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {TeamModel} from '../../../models/api/teamModel';
import {PermissionSimpleDropdownItem} from '../../common/dropdowns/permissionSimpleDropdownItem';
import {EditSidebarCopy} from './editor/copy/edit-sidebar-copy';
import {WorkspaceTeamItem, WorkspaceTeamItemProps} from './workspaceTeamItem';

/*
 * Props.
 */

export interface WorkspaceTeamItemContainerComponentProps extends WorkspaceTeamItemProps {
  onEditWorkspaces: Handler;
  shouldHideMoreMenu: boolean;
  team: TeamModel;
  shouldShowRefinedResultsIndicator: boolean;
}

/*
 * Component.
 */

export const WorkspaceTeamItemContainerComponent: FC<WorkspaceTeamItemContainerComponentProps> = (props) => {
  const componentProps = omit(props, ['onEditWorkspaces', 'shouldHideMoreMenu']);

  const renderMoreMenu = createRenderMoreMenu(props);
  return <WorkspaceTeamItem {...componentProps} renderMenu={renderMoreMenu} />;
};

/*
 * Helpers.
 */

/**
 * For now, these are the same as the helpers for
 * @see WorkspaceGenericItemContainerComponent
 * We can build an abstraction for these during the P1 Declutter project.
 */

function createRenderMoreMenu(
  props: WorkspaceTeamItemContainerComponentProps,
): RendererOf<PopoverTransferProps> | undefined {
  const {shouldHideMoreMenu} = props;

  if (shouldHideMoreMenu) {
    return undefined;
  }

  return (popoverProps) => renderMoreDropdown(popoverProps, props);
}

function renderMoreDropdown(
  popoverProps: PopoverTransferProps,
  props: WorkspaceTeamItemContainerComponentProps,
) {
  const {onEditWorkspaces} = props;

  return (
    <SimpleDropdown {...popoverProps}>
      <PermissionSimpleDropdownItem onSelect={onEditWorkspaces}>
        <EditSidebarCopy />
      </PermissionSimpleDropdownItem>
    </SimpleDropdown>
  );
}
